
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getLeaveTypeById, updateLeaveType } from 'adminApi/LeaveApi/LeaveTypeApi';
import { validateForm } from "utils/validation";
import { LeaveTypeRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditLeaveTypeForm from "./Components/EditLeaveTypeForm";
import fields from "../json/LeaveTypeFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const EditLeaveType = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { formdata } = fields;

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setValues } = useFormChange(
        initialValues,
        LeaveTypeRules
    );

    // Fetch existing data by ID
    const { loading: loadingFetch } = useFetchFormDataById(
        id,
        formdata,
        getLeaveTypeById,
        setValues
    );

    // Form submit
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const formData = new FormData();
            Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
            return await updateLeaveType({ id, data: formData });
        },
        (vals) => validateForm(vals, LeaveTypeRules),
        () => navigate(-1),
        "Leave Type updated successfully"
    );

    return (
        <>
            {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}
            <EditLeaveTypeForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
            />
        </>
    );
};

export default EditLeaveType;
